import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { AdvancedMarker, Map, Pin, useMap } from '@vis.gl/react-google-maps';

import useWindowDimensions from '../../hooks/useWindowDimensions';

const DEFAULT_ZOOM = 15;
const MULTI_LOCATION_PADDING = 80;

function IndotechMap({ locations }) {
    const { isMobile } = useWindowDimensions();
    const map = useMap();

    const hasMultipleLocations = locations.length > 1;
    const firstCoordinates = locations[0]?.coordinates ?? { lat: 0, lng: 0 };

    const mobileStyle = `h-[200px]`;
    const browserStyle = `flex flex-1 items-center justify-center p-20`;

    const fitBoundsToLocations = useCallback(() => {
        if (!map || !hasMultipleLocations) {
            return;
        }

        const bounds = new window.google.maps.LatLngBounds();

        locations.forEach((location) => {
            bounds.extend(location.coordinates);
        });

        map.fitBounds(bounds, MULTI_LOCATION_PADDING);
    }, [map, locations, hasMultipleLocations]);

    return (
        <div className={`${isMobile ? mobileStyle : browserStyle} border border-indotech-primary_blue`}>
            <div className={`flex h-full flex-1 overflow-hidden border sm:rounded-2xl`}>
                <Map
                    mapId={process.env.REACT_APP_GOOGLE_MAP_ID}
                    defaultZoom={DEFAULT_ZOOM}
                    defaultCenter={firstCoordinates}
                    onTilesLoaded={hasMultipleLocations ? fitBoundsToLocations : undefined}
                >
                    {locations.map((location) => (
                        <AdvancedMarker
                            key={location.address}
                            position={location.coordinates}
                        >
                            <Pin
                                background={'#FBBC04'}
                                glyphColor={'#000'}
                                borderColor={'#000'}
                            />
                        </AdvancedMarker>
                    ))}
                </Map>
            </div>
        </div>
    );
}

IndotechMap.propTypes = {
    locations: PropTypes.array,
};

IndotechMap.defaultProps = {
    locations: [],
};

export default IndotechMap;
